'use strict';

import React from 'react'

import MenuItem from '@Pure/MenuItem'
import Link     from '@Pure/Link'

import { isTrue } from '@root/utility'

const app = window.app;

const qwest = window.qwest;

export default class ECAdminSubmenu extends React.Component
{
	handleSessionSwitch = () =>
	{
		const props = this.props, component = this;

		qwest.post('/switch-as-EC')
		.then(function (xhr, response)
		{
			app.state.session = response.session;

			app.state.cart = [];

			app.state.session.order_process =
			{
				'billing': { },
				'shipping': { },
				'payment': { }
			};

			app.emit('sessionChange', { label: 'switch-as-EC' });

			props.history.push('/accueil');
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const props = this.props, component = this;

		let partners_access;

		if (app.state.session.partners && app.state.session.partners.length)
		{
			partners_access =
			(
				<MenuItem base_class="c-sub-menu__item" path="/espace-partenaires"
					history={ props.history }>
					<Link className="c-sub-menu__link" href="/espace-partenaires">
						Gérer mes fiches partenaire
					</Link>
				</MenuItem>
			);
		}

		const syner_kado = isTrue(props.sorewards) ?
		(
			<MenuItem base_class="c-sub-menu__item" path="/accueil/mon-compte/syner-kado"
				history={ props.history }>
				<Link href="/accueil/mon-compte/syner-kado" className="c-sub-menu__link">
					Syner'Kado
				</Link>
			</MenuItem>
		)
		: undefined;

		let output =
		(
			<div className={ 'c-sub-menu' +
				(props.open ? ' c-sub-menu--open' : '') }>

				<ul className="c-sub-menu__menu">

					{
						props['can-use-abondement'] ?
						(
							<li className="c-sub-menu__item is-abondement">
								<span className="c-sub-menu__link is-abondement"
									onClick={ props.onAbondementClick }>
									Abondement&nbsp;: { props.abondement }&nbsp;€
								</span>
							</li>
						)
						: undefined
					}

					<MenuItem base_class="c-sub-menu__item" path="/accueil/mon-compte"
						history={ props.history }>
						<Link href="/accueil/mon-compte" className="c-sub-menu__link">
							Mon compte
						</Link>
					</MenuItem>

					{ syner_kado }

					<MenuItem base_class="c-sub-menu__item" path="/panier"
						history={ props.history }>
						<Link href="/panier" className="c-sub-menu__link">
							Panier
						</Link>
					</MenuItem>

					<MenuItem base_class="c-sub-menu__item" path="/mes-commandes"
						history={ props.history }>
						<Link href="/mes-commandes" className="c-sub-menu__link">
							Mes commandes
						</Link>
					</MenuItem>

					<MenuItem base_class="c-sub-menu__item" path="/mes-factures"
						history={ props.history }>
						<Link href="/mes-factures" className="c-sub-menu__link">
							Mes factures
						</Link>
					</MenuItem>

					{ partners_access }

					<MenuItem base_class="c-sub-menu__item"
						history={ props.history }>
						<button className="c-sub-menu__link"
							onClick={ component.handleSessionSwitch }>
							Passer en mode administrateur
						</button>
					</MenuItem>

					<MenuItem base_class="c-sub-menu__item" path="/logout"
						history={ props.history }>
						<a href="/logout" className="c-sub-menu__link" onClick={ props.logout }>
							Déconnexion
						</a>
					</MenuItem>

				</ul>

			</div>
		);

		return output;
	}
}